/* eslint-disable */
import api from "../services/api";
import { $Q, $Qll } from "../utils/query-selector";
import { dataToggle, toggleDataActive } from "../utils/toggle-dataset";
import { updateHeaderCartCounter } from "./header";

import {
  updateCartItems,
  updatetotalPrice,
  updatePriceItem,
  updateCartbutton,
  updateUpsell,
  updateButtonCheckout,
} from "./update-cart";
import { barProgress } from "../utils/bar-progress";
import { sliderUpsell } from "./slider-swiper";
import { singleCloseQuickModal } from "./product-modal";

const CART_SECTION = "side-cart,cart-page";

barProgress($Q('#progress-bar-data'));
sliderUpsell();


/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-cart-js' in form product
 * */
export const btnAddToCart = (formQuery, parent) => {
  const addForms = $Qll(formQuery, parent);

  if(addForms != null) {
    addForms.forEach(
      form => {
        submitForm(form);
      }
    )
  }
}

export const submitForm = (form, quickshop) => {
  return form.addEventListener(
    "submit",
    (e) => {
      e.preventDefault();

      if (e.target.dataset.isDefault === "true") {
        productDefault(e, quickshop);
        return;
      }

      productPrincipal(e);
    }
  )
}

/**
 * Validate if there button has data-url and link to url
 * @param {node} btn -node button add to cart
 * @author Sebastián García <sebastian.garcia@gradiweb.com>
*/
const validateAndLinkUrl = ( btn ) => {
  if( btn.dataset.url ){
    window.location = btn.dataset.url;
    return true;
  }
  return false;
}

/**
 * Get selling plan with select and input radio
 * @param {node} target form
 * @returns {string} - selling_plan - selling_id
 * @author Daniel Santos
 */
const getSellingPlan = (target) => {
  let container = $Q('.subscription-form__select', target)

  if (container) {
    return container.value;
  } else {
    container = $Q('.subscription-form__radio-options', target)

    if (!container) return;

    const input = $Q('[name="selling_plan"]:checked', target)

    return input.value;

  }
}

/**
 * Create the object of the product principal and search if the product have adicional products with subscription and OTP
 * @param {event} target -node of the submit event for button add to cart
 */
const productPrincipal = ({target}) => {
  const returnTo = $Q('[name="return_to"]', target);
  if (returnTo) {
    target.submit();
    return
  }

  const itemId = $Q('[name="id"]', target).value;
  let sellingPlanId = 0;
  let type = 'otp';

  const widgetSubscription = suscriptionValidation(target);

  if (widgetSubscription) {
    type = $Q('[name="type"]:checked', target).value;
    sellingPlanId = getSellingPlan(target);
  }

  let cardsActive = $Qll('.result-cards-js .funnel-product-js', target); // Default funnel
  if (!cardsActive.length) cardsActive = $Qll('.funnel-product-card-js[data-checked="true"]', target); // Main funnel

  const collectionCards = []

  if (cardsActive.length) {
    cardsActive.forEach(element => {
      productWithCollections(target, element, collectionCards);
    });
  }

  const cartParams = {
    items: [
      {
        id: itemId,
        quantity: 1,
      },
      ...collectionCards,
    ],
    sections: CART_SECTION
  };

  if(sellingPlanId && type === 'subscription') {
    cartParams.items[0]['selling_plan'] = sellingPlanId;
  }

  addProducts({
    cartParams,
    type: type === 'otp' && 'default',
    target
  })
}

/**
 * Capture the array of object with the products collection information
 * @param {event} target -node of the submit event for button add to cart
 * @param {node} element -node of the product card
 * @param {array} collectionsCards -empty array for store the objects items
 */
const productWithCollections = (target, element, collectionsCards) => {
  const itemId = $Q('[name="funnelid"]', element).value;
  console.log(element);
  const itemQuantity = element.getAttribute('data-quantity');
  let sellingPlanId = 0;
  let type = 'otp';

  const widgetSubscription = suscriptionValidation(target);

  if (widgetSubscription) {
    type = $Q('[name="type"]:checked', target).value;
    sellingPlanId = selectSellingid(element).toString();
  }

  if(sellingPlanId && type === 'subscription') {
      collectionsCards.push({
        id: itemId,
        quantity: itemQuantity,
        selling_plan: sellingPlanId,
      }
    )
  } else {
      collectionsCards.push({
        id: itemId,
        quantity: 1,
      }
    )
  }

  return collectionsCards
}

/**
 * Add product to product default
 * It is added for quantity
 * @param {event} target - node of submit event for button add to cart
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
const productDefault = ({ target }, quickshop) => {
  const itemId = $Q('[name="id"]', target).value;
  const sellingPlan = $Q('[name="selling_plan"]', target);
  const quantity = $Q(".js-input-quantity", target).value;

  const cartParams = {
    items: [
      {
        id: itemId,
        quantity,
      }
    ],
    sections: CART_SECTION,
  };

  if (sellingPlan) {
    const RadioType = $Q('[name="type"]:checked', target);
    const saleType = RadioType && RadioType.value;

    if (saleType === 'subscription') {
      cartParams.items[0]['selling_plan'] = sellingPlan.value;
    }
  }

  addProducts({cartParams, type: 'default', quickshop, target});
}

/**
 * Add products in cart
 * @param {arryobject} cartParams -object
 * @param {string} type - What product type did request
 */
const addProducts = async ({cartParams, type, quickshop, target}) => {
  const cartBtn = $Q('.btn-cart-js' , target);
  const contentButton = addSpinner(cartBtn);

  //Validate if there are products with price 0 in the cart
  if (await readCartPage(target)) {
    openSingleCart(target)
    return;
  }

  const response = await api.addToCart(cartParams);

  //Validate if there button has data-url for link
  if( validateAndLinkUrl ( cartBtn ) ){
    return;
  }

  if (response != undefined) {
    updateButtonProductPage($Q('.btn-cart-js', target));
    updateCartItems(response.sections['side-cart']);
    updatetotalPrice(response.sections['side-cart']);
    updateCartbutton(response.sections['side-cart']);
    updateUpsell(response.sections['side-cart']);
    updateHeaderCartCounter(response.item_count);
    updateButtonCheckout(
      response.sections['side-cart'],
      response.sections['cart-page']
    );

    if (quickshop) singleCloseQuickModal()

    openSingleCart(target)

    //Remove loader of button that doesn't have section rendering
    removeSpinner($Q('.btn-cart-js' , target), contentButton)
  } else {
    stateStock();
  }
}

/**
 * Block button when the product added is pack or kit
 * @param {node} btn - add to cart funnel button
 * @author Daniel Santos
 */
const updateButtonProductPage = (btn) => {
  const btnMainProduct = $Q('.main-product-js .btn-cart-js')

  if (!btnMainProduct) return;

  validateButtonProductPage(btn, btnMainProduct, 'PACK')
  validateButtonProductPage(btn, btnMainProduct, 'PLUS')
  validateButtonProductPage(btn, btnMainProduct, 'Kit')
}

/**
 * Validate type product and add class
 * @param {node} btn - Trigger button
 * @param {node} btnMainProduct - Button to update
 * @param {string} productType - type product
 * @see updateButtonProductPage
 */
const validateButtonProductPage = (btn, btnMainProduct, productType) => {
  if (btn.dataset.productType === productType && btnMainProduct.dataset.productType === productType) {

    if(!btnMainProduct.classList.contains('disabled-kit')) {
      btnMainProduct.classList.add('disabled-kit')
    } else {
      btnMainProduct.classList.remove('disabled-kit')
    }
  }
}

/**
 * Open Side Cart when the cart request is OK
 * @param {object} target
 */
const openSingleCart = (target) => {
  if (target.dataset.form !== "upsell") {
    dataToggle($Q("#shopify-section-side-cart"), true, true);
  }
}

/**
 * Get elements added at the cart
 * @returns {boolean} true if there are produtcs with price zero in the cart
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
export const readCartPage = async (item) => {

  if (item) {
    const itemCurrentPrice = Number.parseInt($Q('.btn-cart-js', item).dataset.price, 10)

    const { items } = await api.read('/cart.js')

    if (!items) return;

    return validateItemsPriceZero(items, itemCurrentPrice) || validateItemsTypeProduct(items, 'PACK', item) || validateItemsTypeProduct(items, 'PLUS', item)
  }
}

/**
 * Get products items with price 0
 * Let one in the cart and remove another products items with price 0
 * Update interface
 * @param {array} items - Items cart
 * @return {boolean} true if there are produtcs with price zero in the cart
 * @author Daniel Santos
 */
const validateItemsPriceZero = (items, itemCurrentPrice) => {
  const itemsZero = items.some(product => product.final_price === 0)

  if(itemCurrentPrice === 0 && itemsZero) return true;
}

/**
 * Get products items type 'PACK'
 * Let one in the cart and remove another products items type 'PACK'
 * Update interface
 * @param {array} items - Items cart
 * @param {string} type - product type
 * @return {boolean} true if there are produtcs type 'PACK' in the cart
 * @author Daniel Santos
 */
const validateItemsTypeProduct = (items, type = 'PACK', itemCurrent) => {
  const itemsProductType = items.some(product => product.product_type === type)
  const currentProductType = $Q('.btn-cart-js', itemCurrent).dataset.productType

  if (currentProductType === type && itemsProductType) return true;
}

/**
 * Replace en element with a spinner
 * @param {node} element
 * @returns {array} content - array of childNodes
 */
const addSpinner = (element) => {
  if (!element) return;

  const content = [...element.childNodes];

  element.disabled = true;
  element.innerHTML = "<div class='spinner'></div>";

  return content;
}

/**
 * Remove spinner element
 * Insert content button
 * For elements that don't has section rendering
 * @param {node} element
 * @param {array} content - array of nodes with elemento content
 */
const removeSpinner = (element, content) => {
  if (!element || !$Q('.spinner', element)) return;

  $Q('.spinner', element).remove();

  element.append(...content);
  if(element.disabled) element.disabled = false;
}

/**
 * Event onChange in the cart item
 */

export const onChangeItemCart = () => {
  $Qll('.item-cart-js').forEach(
    input => {
      input.addEventListener(
        'change',
        function () {
          updateCart(this.dataset.index, this.value, this.id);
        }
      )
    }
  )
}

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 */
export const updateCart = async (line, quantity, id, target) => {
  addSpinner($Q(`#price-${id}-${line}`));

  const cartParams = {
    line,
    quantity,
    sections: CART_SECTION,
  }

  const { sections = null, item_count, total_price } = await api.changeCart(cartParams);
  if (!sections) return null;

  if (Number(quantity) == 0) {
    updateCartItems(sections['side-cart']);
    updateCartbutton(sections["side-cart"]);
    updatetotalPrice(sections['side-cart'], sections['cart-page']);
    updateUpsell(sections['side-cart']);
    updateHeaderCartCounter(item_count)
    updateButtonCheckout(sections['side-cart'], sections['cart-page']);
    updateButtonProductPage(target)
  } else {
    updatePriceItem(sections['side-cart'], `${id}-${line}`);
    updatetotalPrice(sections['side-cart'], sections['cart-page']);
    updateCartbutton(sections['side-cart']);
    updateHeaderCartCounter(item_count);
    updateButtonCheckout(sections['side-cart'], sections['cart-page']);
    updateButtonProductPage(target)
  }

  total_price && (window.basketValue = total_price / 100);
}


/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = () => {
  const deleteIcon = $Qll(".item-delete");

  if (deleteIcon) {
    deleteIcon.forEach(
      element => {
        element.addEventListener(
          "click",
          () => {
            updateCart(element.dataset.index, 0, element.dataset.id, element)
          }
        )
      }
    );
  }
}

/**
 * Filter the selling id for the product principal, in all sellings id of the product in collection
 * @param {node} element -node of the product card
 */

const selectSellingid = (element) =>{
  const sellingElement = $Q('[name="selling_plan"]');

  let productSellingName = sellingElement.nodeName === 'INPUT'

  if (productSellingName) {
    productSellingName = $Q('[name="selling_plan"]:checked').dataset.name
  } else  {
    productSellingName = sellingElement.options[sellingElement.selectedIndex].dataset.name
  }

  const sellings = JSON.parse($Q('#selling', element).value)[0].selling_plans;

  const sellingFilter = sellings.filter(
    selling => selling.name == productSellingName
  )

  return sellingFilter[0].id
}

/**
 * Validate if the product have subscription
 * @param {event} target -node of the submit event for button add to cart
 */

const suscriptionValidation = (target) => {
  const widgetSubscription = $Q('.subscription-form', target.closest('.product-js'))
    ? true
    : false;

  return widgetSubscription
}

/**
 * This function checks the status of the stock to activate or deactivate a message
 */
 const stateStock = () => {
  const stockActive = $Q('#advice-wraper');
  if(!stockActive) return;

  stockActive.dataset.active = 'true';
  setTimeout(function(){
    stockActive.dataset.active = 'false';
  },5000);
}

/**
 * Read items is in the cart
 * @returns {object} response api
 * @author Daniel Santos <daniel.santos@gradiweb.com>
 */
export const readCart = async () => await api.read('/cart.js')


/**
* Open and close side cart with various buttons
*/
export const openCloseCart = () => {
  const cartContainer = $Q('.cart');
  cartContainer.setAttribute('data-active', 'false');

  toggleDataActive(
    '.js-cart-close',
    '#shopify-section-side-cart',
    { overlay: true, bodyBlocked: true },
  )

  toggleDataActive(
    '.js-button-cart',
    '#shopify-section-side-cart',
    { overlay: true, bodyBlocked: true },
  )
}

/**
 * Check if customer logged and saved variable in sessionStorage
 * @return {void}
*/
export const checkCustomerLogged = () => {
  const checkBtnElement = $Q("#checkout-sidecart-js");

  if (!checkBtnElement) return;

  const aRefElement = $Q(".button-container-js a", checkBtnElement);

  aRefElement.onclick = () => {
    sessionStorage.setItem("returnCheckout", true);
  }
}

